<template lang="pug">
  #authenticate
    .loginpage
      .container
        .col-md-4.col-xs-8.login-portion
          .login-form.panel.row-inlineblock
            .panel-heading
              h2.panel-title パスワード再設定
            .panel-body
              p 新しいパスワードを入力してください
              .form-group
                label.control-label(for='pass1') 新しいパスワード
                .input-group
                  span.input-group-addon
                    span.fa.fa-lock.fa-fw
                  input#pass1.form-control(type='text' v-model='password1' placeholder='パスワードを入力してください')
              .form-group
                label.control-label(for='pass2') 新しいパスワード(確認)
                .input-group
                  span.input-group-addon
                    span.fa.fa-lock.fa-fw
                  input#pass2.form-control(type='text' v-model='password2' placeholder='パスワードを入力してください')
              .form-group
                .alert.alert-danger(v-show='error_message' v-html='error_message')
                .alert.alert-success(v-show='success_message' v-html='success_message')
                button#button.btn.btn-success.btn-lg.btn-block(@click='send()' v-show='!success_message') 設定
                router-link(to='/auth/login' v-show='success_message') ログインはこちらから
</template>

<style lang="stylus">
</style>

<script>
import loader from '@/service/Loader'
import qs from 'querystring'
import Request from '@/service/Request'
export default {
  data () {
    return {
      password1: null,
      password2: null,
      error_message: null,
      success_message: null
    }
  },
  methods: {
    send () {
      loader.show()
      let axios = Request.instance()
      this.error_message = null
      this.success_message = null
      axios.post(
        '/client/auth/reset_password',
        qs.stringify({
          token: this.$route.params.token,
          password: this.password1
        })
      ).then((res) => {
        this.success_message = 'パスワードの変更が完了しました。'
      }).catch((error) => {
        this.error_message = error.response.data.message
      }).then(() => {
        loader.hide()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?599640d5